<template>
  <div class="benefit__card-scene">
    <div
      ref="card"
      :class="['benefit__card', {'is-flipped': isFlipped}]"
      @click="flipCard"
    >
      <span class="is-sr-only">{{ !isFlipped ? frontDescriptionLabel : backDescriptionLabel }}</span>
      <slot name="card-frontside" />
      <slot name="card-backside" />
    </div>
  </div>
</template>

<script>
  export default {
    name: 'BenefitCard',
    props: {
      frontDescriptionLabel: { required: true, type: String },
      backDescriptionLabel: { required: true, type: String }
    },
    data() {
      return {
        isFlipped: false,
      };
    },
    mounted() {
      this.setCardFacePosition();
    },
    methods: {
      flipCard() {
        if (!this.$refs.card.children) {
          return;
        }

        this.isFlipped = !this.isFlipped;
        this.$refs.card.children[1].style.overflow = this.isFlipped ? 'auto' : 'hidden';
      },
      setCardFacePosition() {
        if (!this.$refs.card.children) {
          return;
        }

        const frontside = this.$refs.card.children[1];
        const backside = this.$refs.card.children[2];

        // card get height of the bigger face
        if (frontside.offsetHeight > backside.offsetHeight) {
          backside.style.position = 'absolute';
        } else {
          frontside.style.position = 'absolute';
        }
      }
    },
  };
</script>

